// created by liwei 2018.7.30

import { openAppToast, getAppStorage, setAppStorage, removeAppStorage } from '@lib/bridge.js';
import { wechatConfig, fakeAppVersion} from '../config/config'

//获取公共后端接口请求地址前缀
export const getRequestPrefix = () => {
    return '/feed-server/';
};

export const getUserInfoRequestPrefix = () => {
    return '/userinfo-server/';
};

//获取公共后端接口请求地址前缀
export const getCommentRequestPrefix = () => {
    return '/comment-server/';
};

//获取指定大小范围的随机数
export const getRandomNumber = (min, max) => {
    return Math.round(Math.random() * (max - min)) + min;
};

/**
 * 获取客户端版本号
 *
 */
export const getAppVersion = () => {
    const arr = window.navigator.userAgent.match(/imv\/((\d\.?)+)/);
    return arr?.[1] || '';
};

 /**
 * 获取客户端版本号加权求和值
 */
export const getAppVersionNumber = (targetVersion) => {
    if(targetVersion?.length){
        const version = targetVersion.split('.');
        return +version[0] * 1000000 + +version[1] * 1000 + +version[2];
    }else{
        return 0;
    }
};

/**
 * 获取客户端版本号加权求和值
 */
export const compareAppVersion = (targetVersion) => {
    return getAppVersionNumber(getAppVersion()) >= getAppVersionNumber(targetVersion);
};


/**
 * 格式化日期
 * @param {String} format  日期格式，比如：yyyy-MM-dd hh:mm:ss
 * @param {object Date} date 日期对象
 */
export const getFormatTime = (format, date) => {
    var o = {
        'M+': date.getMonth() + 1, //month
        'd+': date.getDate(), //day
        'h+': date.getHours(), //hour
        'm+': date.getMinutes(), //minute
        's+': date.getSeconds(), //second
        'q+': Math.floor((date.getMonth() + 3) / 3), //quarter
        S: date.getMilliseconds() //millisecond
    };

    if (/(y+)/.test(format)) {
        //RegExp.$1  执行完正则表达式后，匹配的第一项（if语句中匹配的第一项）
        format = format.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    for (var k in o) {
        if (new RegExp('(' + k + ')').test(format)) {
            format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
        }
    }
    return format;
};

/**
 * 格式化时间
 * @param {Number} stmp 时间戳
 */
export const getRelativeTime = stmp => {
    const now = Date.now();
    const date_now = new Date();
    const date_pass = new Date(stmp);
    const year_now = date_now.getFullYear();
    const year_pass = date_pass.getFullYear();
    const time = now - stmp;
    let content = '';

    //5分钟内
    if (time <= 5 * 60 * 1000) {
        content = '刚刚';
        // 5分钟之外1小时内
    } else if (5 * 60 * 1000 < time && time <= 60 * 60 * 1000) {
        content = `${parseInt(time / 60 / 1000)}分钟前`;
        // 1小时外1天内
    } else if (60 * 60 * 1000 < time && time <= 24 * 60 * 60 * 1000) {
        content = `${parseInt(time / 60 / 60 / 1000)}小时前`;
        // 1天外5天内
    } else if (24 * 60 * 60 * 1000 < time && time <= 5 * 24 * 60 * 60 * 1000) {
        content = `${parseInt(time / 24 / 60 / 60 / 1000)}天前`;
    } else {
        if (year_now === year_pass) {
            content = getFormatTime('MM月dd日', new Date(stmp));
        } else {
            content = getFormatTime('yyyy年MM月dd日', new Date(stmp));
        }
    }
    return content;
};

//查询url后传递的字符串参数 json
export const getUrlParamas = urlSearch => {
    urlSearch = urlSearch || location.search;
    //取得查询字符串并去掉开头的问号，location.search返回?以后的字符串
    if (urlSearch.indexOf('?') !== -1) {
        urlSearch = urlSearch.slice(1);
    }

    const queryString = urlSearch.length ? urlSearch : '';
    let result = {};
    let items = queryString.length ? queryString.split('&') : [];
    let name, value;

    //逐个将每一项添加到args对象中
    items.forEach(item => {
        item = item.split('=');
        //url后的参数浏览器会对其进行编码（encodeURIComponent），此处进行解码操作。
        name = window.decodeURIComponent(item[0]);
        value = window.decodeURIComponent(item[1]);
        if (name && name.length) {
            result[name] = value;
        }
    });

    return result;
};

//根据url参数名，查询参数值
export const getQueryValue = str => {
    const obj = getUrlParamas();
    return obj[str] || '';
};

//前端页面跳转
export const gotoPage = path => {
    const pathArray = path.split('#');
    let url = '';
    if (window.location.href.indexOf('/web-server/html/') !== -1) {
        url = '/web-server/html/' + pathArray[0];
    } else {
        url = '/html/' + pathArray[0];
    }

    //安卓端status高度
    let barHeight = window.parseInt(getQueryValue('statusbar'), 10);
    if (barHeight === barHeight) {
        url += (url.indexOf('?') === -1 ? '?' : '&') + 'statusbar=' + barHeight;
    }
    window.location.href = url + (url.indexOf('?') === -1 ? '?' : '&') + 'timestamp=' + new Date().getTime() + ('#' + pathArray[1] || '');
};

//获取cookie中某一项的值
export const getCookieValue = name => {
    const arr = document.cookie.match(new RegExp('(^| )' + name + '=([^;]*)(;|$)'));

    if (arr != null) {
        return decodeURIComponent(arr[2]);
    } else {
        return null;
    }
};

//设置cookie的值
export const setCookieValue = (name, value, time) => {
    const now = new Date();
    const offset = 8;
    const utc = now.getTime() + now.getTimezoneOffset() * 60000;
    const nd = utc + 3600000 * offset;
    const exp = new Date(nd);
    const domain = document.domain;
    exp.setTime(exp.getTime() + time * 60 * 60 * 1000);
    document.cookie = name + '=' + escape(value) + ';path=/;expires=' + exp.toGMTString() + ';domain=' + domain + ';';
};

/**
 * 为内嵌安桌的页面空出状态栏的高度 IOS高度有规律直接css实现了
 * @param {object HTMLDomElement} dom 将要设置头部padding的元素 默认是document.body
 */
 export const fixedAndroidStatusBar = dom => {
    let barHeight = window.parseInt(getQueryValue('statusbar'), 10);
    dom = dom || document.body;
    if (barHeight === barHeight) {
        dom.style.paddingTop = barHeight + 'px';
    } else {
        dom.style.paddingTop = '0px';
    }
};

//公共后端接口请求参数
export const getRequestCommonQuery = () => {

    const ppList = ['app', 've', 'fr', 'md', 'os', 'oc', 'isp', 'lon', 'lat', 'lan', 'cc', 'did', 'mi', 'nt', 'sr', 'sig', '_did', 'egid'];
    let result = {};
    ppList.map(key => {
        let value = getCookieValue(key);
        if (value) {
            result[key] = value;
        }
    });

    result.app = 'highsheng';
    if (!result.ve) {
        result.ve = fakeAppVersion || '1.0.0';
    }
    if (!result.did) {
        result.did = result._did || getCookieValue('weblogger_did');
        // 最终兜底
        if(!result.did){
            const temp = 'web_imv_' + Date.now() + getRandomNumber(1, 10000000);
            result.did = temp;
            setCookieValue('did', temp, 999999);
        }
    }

    return result;
};

//获取对象序列化字符串
export const getSerialize = obj => {
    let str = '';
    for (let key in obj) {
        str += ((str && '&') || '') + `${key}=${obj[key]}`;
    }
    return str;
};

export const getSerializeCommonQuery = () => {
    return getSerialize(getRequestCommonQuery());
};

//公共后端接口请求参数FormData版
export const getRequestCommonFormDataQuery = () => {
    let query = getRequestCommonQuery();
    let formData = new FormData();
    for (let key in query) {
        formData.append(key, query[key]);
    }
    return formData;
};

// 判断浏览器是否支持webp 自动替换url后缀
export const checkSupportWebp = (() => {
    let support = false;
    try {
        //判断浏览器是否支持webp
        if (/data:image\/webp/gi.test(document.createElement('canvas').toDataURL('image/webp'))) {
            //支持webp
            support = true;
        } else {
            //不支持webp
            support = false;
        }
    } catch (err) {
        //不支持webp
        support = false;
    }
    return () => support
})();

//自动识别是否支持webp, 在不支持的环境替换webp为jpg
export const autoReplaceWebpToJpg = url => {
    let support = checkSupportWebp();
    if (support) {
        return url || '';
    } else {
        return (url && url.replace(/webp$/i, 'jpg')) || '';
    }
};

// 自动识别是否支持 webp, 支持的环境替换 jpg 为 webp
export const autoReplaceJpgToWebp = (url = '') => checkSupportWebp() ? url.replace(/jpe?g$/i, 'webp') : url;

/**
 * 自动处理webp图片
 */
 export const autoAdaptWebp = imageArray => {
    const isSupport = checkSupportWebp();
    if (isSupport) {
        return (imageArray[0] && imageArray[0].url) || '';
    } else {
        const jpgImage = imageArray.find(item => {
            return item.url.match(/.+(jpg|jpeg)$/);
        });
        // console.log('jpgImage', jpgImage)
        return (jpgImage && jpgImage.url) || (imageArray[0] && imageArray[0].url) || '';
    }
};

/**
 * 自动处理webp图片url (仅使用于图片存储统一采用format格式的新项目 找服务端确认)
 */
export const autoAdaptWebpUrl = (url) => {
    return checkSupportWebp() ? url : url.replace('format,webp', 'format,jpg');
};

//判断是否是IOS端
export const isIOS = () => {
    return /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent);
};

//判断是否是Android端
export const isAndroid = () => {
    return /(Android|Adr)/i.test(navigator.userAgent);
};

//判断是否是鸿蒙端
export const isHarmony = () => {
    return /(HarmonyOS|ArkWeb)/i.test(navigator.userAgent);
};

// 反馈系统标识
export const getSystem = () => {
    if(isAndroid()){
        return 'android';
    }else if(isIOS()){
        return 'ios';
    }else{
        return 'harmony';
    }
};

// 判断是否为 PC 端打开
export const isPC = () => !(isIOS() || isAndroid() || isHarmony());

//判断是否是微信内
export const isWechat = () => {
    return /MicroMessenger/i.test(navigator.userAgent);
}

//判断是否是QQ内
export const isQQ = () => {
    return /qq\/([\d.]+)/i.test(navigator.userAgent);
};

// 判断是否微博内
export const isInWeibo = () => {
    return /Weibo/i.test(navigator.userAgent);
}

// 判断是否小米手机
export const isXiaomi = () => {
    return /Xiaomi/i.test(getCookieValue('mod')) || /(HM|Mi|mix|RK\d+C)(\s|-)/i.test(navigator.userAgent);
}

// 判断是否华为手机
export const isHuawei = () => {
    return /HUAWEI|HONOR|HarmonyOS|ArkWeb/i.test(navigator.userAgent);
};

//判断是否是端内
export const isInApp = () => {
    return /imv/i.test(navigator.userAgent);
};

// 判断是否是快手内
export function isInKwai() {
    return /Kwai\/|Kwai_Lite\/|Kwai_Pro\/|ksNebula\//i.test(navigator.userAgent);
}

export const openApp = {
    openProgress(direct, url) {
        if (direct) {
            window.location.href = url;
        } else {
            return url;
        }
    },
    //跳转到App个人页
    gotoAppProfile(direct, id) {
        const url = 'imv://profile/:' + id;
        return this.openProgress(direct, url);
    },
    //跳转到App作品详情页
    gotoAppVideo(direct, id) {
        const url = 'imv://work/:' + id;
        return this.openProgress(direct, url);
    },
    //跳转到App首页首页
    gotoAppIndex(direct) {
        if (direct) {
            location.href = 'imv://';
        } else {
            return '';
        }
    },
    //端外打开App
    outerOpen(openPage, id) {
        /* if(isIOS()){
            setTimeout(() => {
                location.href = 'https://itunes.apple.com/cn/app/id1401839434?mt=8';
            }, 1000);
            this[openPage](true, id);
        }else{ */
        const value = window.encodeURIComponent(this[openPage](false, id));
        location.href = `http://a.app.qq.com/o/simple.jsp?pkgname=com.kwai.hisense&ckey=CK1417121725951&ios_schema=${ value }&android_schema=${ value }`;
        //}
    },

    openSchema(schemaUrl, downloadUrl) {
        const isAndroid = /(Android|Adr)/i.test(navigator.userAgent);
        const downloadAppIfNotOpened = (callback) => {
            var count = 0;
            var startTime = +new Date();
            var intHandle = setInterval(function () {
                count++;
                var durTime = +new Date() - startTime;
                if (count > 49) {
                    clearInterval(intHandle);
                    if (durTime < 1300) {
                        if (typeof callback == 'function') {
                            callback();
                        }
                    }
                }
            }, 20);
        }
        if (!schemaUrl) {
            return;
        }
        if (isAndroid) {
            console.log(isAndroid, schemaUrl, downloadUrl);
            // let ifr = document.createElement('iframe');
            // ifr.src = schemaUrl;
            // ifr.style.display = 'none';

            // document.body.appendChild(ifr);
            // setTimeout(function () {
            //     document.body.removeChild(ifr);
            // }, 100);
            window.location.href = schemaUrl;
        } else {
            window.location.href = schemaUrl;
        }
        if (isAndroid) {
            downloadAppIfNotOpened(function () {
                window.location.href = downloadUrl;
            });
        } else {
            setTimeout(function () {
                window.location.href = downloadUrl;
            }, 50);
        }
    }
};

//获取JSBridge回调函数
export const getJSBridgeCallBack = (callback, method = 'JSBridgeCallback', api = '', params, getParameters ) => {
    const timestamp = new Date().getTime();
    const bridgeName = `${method + timestamp + getRandomNumber(1, 10000000)}`;
    const reportCallback = function (data) {
        try {
            if (data) {
                let res;
                // 兼容android低端手机，其webview做多了一层url encode
                if (/^%7B%5C%22/.test(data)) {
                    data = decodeURIComponent(data);
                    data = data.replace(/\\"/g, '"');
                }

                if (typeof data === 'string') {
                    res = JSON.parse(data);
                }
                // http错误都加了一个-200000的偏移量，比如-200401， -200500；
                // 本地的异常还是 0 = cancel， 1=success， 105 = network not connected，412 = fail；剩下的错误码都是服务端返回的业务code
                const { result, error_msg } = res;
                if (!result || !error_msg || result === 1 || result === 0) {
                    // result为空/error_msg为空/result为0/result为1 不上报
                    return;
                }
                // http请求错误
                let httpStatus;

                if (result && String(result).indexOf('-200') > -1) {
                    httpStatus = +String(result).split('-200')[1];
                }
                console.log(
                    `JSBridgeError, code: ${result}, msg: ${error_msg}, api: ${api}, httpStatus: ${httpStatus}`
                );
                // const reportParams = {
                //     event: 'JSBridgeError',
                //     err_code: result,
                //     error_msg: error_msg,
                // };

                // reportParams.api = api ? api : method;

                // if (params) {
                //     reportParams.params = params;
                // }

                // if(getParameters) {
                //     reportParams.getParameters = getParameters;
                // }

                // if (httpStatus) {
                //     reportParams.http_status = httpStatus;
                // }
                // webviewLog(reportParams);
            }
        } catch (err) {
            console.log(`JSBridge report error:`, err);
        }
    };

    // 旧版兼容
    // window[bridgeName] = function (data) {
    //     callback && callback(data);
    //     reportCallback(data);
    //     // 客户端监听JS 不销毁已注册事件
    //     (method !== 'onTriggerEvent' && method !== 'addNotificationObserver') ? (window[bridgeName] = function () {}) : '';
    // };

    // jsBridgeRouter为空时，声明一个对象
    if (!window.jsBridgeRouter) {
        window.jsBridgeRouter = {};
    }

    window.jsBridgeRouter[bridgeName] = function (data) {
        console.log('#####', bridgeName);
        callback && callback(data);
        reportCallback(data);
        // 客户端监听JS 不销毁已注册事件
        (method !== 'onTriggerEvent' && method !== 'addNotificationObserver') ? (window.jsBridgeRouter[bridgeName] = function () {}) : '';
    };

    return bridgeName;
};

// 统一错误处理
export const setCommonErrorTips = data => {
    openAppToast('出错啦, 错误代码：' + data.status + ' ' + data.message);
};

//预渲染页面 只用于确定能判断出用户意图的场景 以免浪费资源
export const prerenderPage = path => {
    let url = '';
    if (window.location.href.indexOf('/web-server/html/') !== -1) {
        url = '/web-server/html/' + path;
    } else {
        url = '/html/' + path;
    }
    let hint = document.createElement('link');
    hint.setAttribute('rel', 'prerender');
    hint.setAttribute('href', url);
    document.getElementsByTagName('head')[0].appendChild(hint);
};

/**
 * 复制文本
 * @param {String} text 被复制的文本
 */
export const copyText = text => {
    const input = document.createElement('input');
    input.setAttribute('readonly', 'readonly');
    input.setAttribute('value', text);
    document.body.appendChild(input);
    //兼容Android
    input.select();
    //兼容IOS
    input.setSelectionRange(0, 9999);
    document.execCommand('copy');
    document.body.removeChild(input);
};
/**
 * 格式化音频时间
 * @param {Number} duration 格式音频时间
 */
export const formatSecondDuration = (duration, currentTime) => {
    duration = Math.floor(duration / 1000);
    return Math.max(duration - currentTime, 0);
};

/**
 * 安全的获取对象的多层级属性, 避免报错
 *  xxx of undefined
 * @param {object} obj 源对象
 * @param {string} path 属性路径
 * @param {any} defaultValue 默认值, 如果源对象中没有需要的属性返回该值
 * @returns
 */
export const deepGet = (obj, path, defaultValue = null) => {
    // 不支持 [] 的方式获取属性
    if (path && path.includes && path.includes('[')) {
        throw new Error('暂不支持 [] 获取属性的方式 ~');
    };

    const pathArr = path.split('.');
    let currentIdx;

    while ((currentIdx = pathArr.shift()) && obj) {
        obj = obj && obj[currentIdx];
    };

    return obj !== undefined ? obj : defaultValue;
}

// 判断对象是否为真实对象
export const isObject = obj => (typeof obj === 'object' && obj) || typeof obj === 'function';

/**
 * 对象深拷贝
 * @param {object} src 源对象
 * @param {weekSet} weekSet 仅内部可用
 * @returns
 */
export const deepClone = (src, weekSet = new WeakSet()) => {
    if (weekSet.has(src)) return src;
    if (!isObject(src)) return src;

    weekSet.add(src);
    const ret = Array.isArray(src) ? [] : {}
    for (const i in src) {
        if (Object.prototype.hasOwnProperty.call(src, i)) {
            ret[i] = deepClone(src[i], weekSet);
        }
    }

    return ret;
}

/**
 * 处理后端返回的数据, 超过 1000 的数据展示 xxxK
 * @param {number} value 真实数字
 * @param {string} placeholder 默认文案占位符
 * @returns
 */
export const computeCount = (value, placeholder = '') => {
    value = +value;

    if(value === 0 || Number.isNaN(value)) {
        return placeholder;
    };

    if (value < 1000) {
        return value;
    };

    return Math.floor(value / 1000) + 'K';
};

// 获取passport接口域名
export const getPassportApi = () => {
    let api;
    if (location.host === 'h5.getkwai.com' || location.host === 'www.zhongnice.com' || location.host === 'zhongnice.com') {
        // 解决Safari无法跨域携带cookie的问题 域名换成mp.tingpiting.com走ngix转发
        // api = 'https://id.getkwai.com';
        // api = 'https://imv-id.viviv.com';
        api = 'https://id.zhongnice.com';
    } else {
        // 2022.3.29 测试环境即将下线 改用staging环境测试
        // api = 'https://imv-id.test.gifshow.com';
        api = 'https://imv-id.staging.kuaishou.com';
    }
    return api;
}

// 支付中台接口
export const getPayApi = () => {
    let api;
    if (location.host === 'h5.getkwai.com' || location.host === 'www.zhongnice.com' || location.host === 'zhongnice.com' || location.host === 'galaxy.test.gifshow.com') {
        api = 'https://www.kuaishoupay.com';
    } else {
        api = 'https://kspay-staging.test.gifshow.com';
    }
    return api;
}

export const getEnv = () => {
    let env;
    if (location.host === 'h5.getkwai.com' || location.host === 'www.zhongnice.com' || location.host === 'zhongnice.com' || location.host === 'imv.tingpiting.com') {
        env = 'production';
    } else {
        env = 'staging';
    }
    return env;
}

// 静态资源协议适配
export const adaptProtocol = (url = '') => url.replace(/^https?:/, '');

// 创建一个空函数, 主要是用于函数类型参数的默认参数
export const noop = () => {}

// visibilitychange
let hidden;
let visibilityChange;
// 兼容
(() => {
    if (typeof document.hidden !== 'undefined') {
        hidden = 'hidden';
        visibilityChange = 'visibilitychange';
    } else if (typeof document.msHidden !== 'undefined') {
        hidden = 'msHidden';
        visibilityChange = 'msvisibilitychange';
    } else if (typeof document.webkitHidden !== 'undefined') {
        hidden = 'webkitHidden';
        visibilityChange = 'webkitvisibilitychange';
    }
})();
export const isPageHidden = () => document[hidden]
export const bindVisibilityChange = (onHidden = noop, onShow = noop) => {
    document.addEventListener(visibilityChange, () => {
        if(isPageHidden()) {
            onHidden();
        } else {
            onShow();
        }
    })
}

export const encodeUserString = str => str ? str.replace(/[<">']/g, htmlTag => (
    {
        '<': '&lt;',
        '&': '&amp;',
        '"': '&quot;',
        '>': '&gt;',
        "'": '&#39;'
    }[htmlTag]
)) : '';

export const sleep = (time = 1e3) => new Promise(resolve => setTimeout(resolve, time))

// 活动信息上报
export const reportActivityStat = (config) => {
    // 业务
    const app = config.app ?? 'imv';
    // 活动
    const activity = config.activity ?? 'activity';
    // 入口
    const ptfrom = config.ptfrom ?? getQueryValue('ptfrom');
    // 页面
    const page = config.page ?? 'index';
    // itemId
    const photoId = config.photoId ?? '';
    // globalId
    const globalId = config.globalId ?? getCookieValue('global_id') ?? getCookieValue('egid') ?? getCookieValue('globalId') ?? '';
    // 用户ID
    const ud = config.uid ?? getCookieValue('ud') ?? getCookieValue('userId') ?? '';
    // did
    const did = config.did ?? getCookieValue('did') ?? '';
    // fr
    const fr = config.fr ?? getCookieValue('kpf') ?? '';

    const extra = config.extra && getSerialize(config.extra) || '';

    config.beforeCallback && config.beforeCallback();

    const img = new Image();
    const baseUrl = `/log-server/api/v1/activity/record?app=${app}&activity=${activity}&page=${page}&photoId=${photoId}&ud=${ud}&did=${did}&fr=${fr}&ptfrom=${ptfrom}${extra ? '&' + extra : ''}&t=${Date.now()}`;

    img.src = `${baseUrl}&globalId=${globalId}`;
};

// 生成待客户端解析的剪贴板数据 统一格式：  #业务-功能#实际数据 整体base64加密
export const getCopyData = (data, subType = 'share') => {
    return window.btoa && btoa(unescape(encodeURIComponent(`#imv-${subType}#${data}`)));
};

// 获取w为单位的数值
export const getRelativeNumText = (num, decimal = 0) => {
    decimal = +`1e${decimal}`;
    return num >= 10000 ? Math.floor(num / 10000 * decimal) / decimal + 'w' : num;
};

// 获取w以上保留一位小数的精简数值
export const getRelativeDotNumText = (num, language = 'en') => {
    if(num < 10000){
        return num;
    }else if(num < 100000000){
        return Math.floor(num / 1000) / 10 + (language === 'cn' ? '万' : 'w');
    }else{
        return Math.floor(num / 10000000) / 10 + (language === 'cn' ? '亿' : 'y');
    }
};

/**
 * 极简节流函数
 * @param {function} fn "大流量"事件处理函数
 * @param {number} wait 等待区间: 这段时间内频繁发生的事件不再响应
 * @param {boolean} tail 最后一次触发是否必须执行
 * @returns {function} 具备节流能力的事件处理函数
 */
export const throttle = (fn, wait = 2e2, tail = false) => {
    let lastInvoke = 0;
    let lastCallMe = 0;
    return (...args) => {
        const now = Date.now();
        lastCallMe = now;

        const fire = () => {
            fn(...args);
            lastInvoke = now;
        }

        if (now - lastInvoke > wait) {
            fire();
        } else if (tail) {
            setTimeout(() => {
                if (Date.now() - lastCallMe >= 100) {
                    fire();
                }
            }, 100);
        }
    }
}  

// 洗牌算法乱序
export const shuffle = (array)  => {
    for (let i = array.length; i; i--) {
        let j = Math.floor(Math.random() * i);
        [array[i - 1], array[j]] = [array[j], array[i - 1]];
    }
    return array;
}

// 判断当前终端是否为 64 位
export const isX64Client = () => {
    const clientInfo = [
        navigator.userAgent.toLowerCase(), 
        navigator.platform.toLowerCase(), 
        navigator.appVersion.toLowerCase()
    ]

    let ret = false
    clientInfo.forEach(text => {
        if (text.includes('armv8l') || text.includes('x64')) {
            ret = true
        }
    })

    return ret
}

/**
 * get 接口缓存
 * @param {String} key 接口缓存 key
 * @param {Number} cacheTime 接口结果缓存时间(单位 ms)
 * @returns 返回可执行函数
 */
export const cacheApi = (key, cacheTime = 1000 * 60 * 60) => apiFunc => {
    if (!key) {
        throw new Error('key 参数为必填参数 ~')
    }
    
    const cachedData = localStorage.getItem(key);
    if (cachedData) {
        try {
            const {data, expire} = JSON.parse(cachedData);
            if (Date.now() < expire) {
                return () => Promise.resolve(data);
            } else {
                localStorage.removeItem(key);
            }
        } catch (error) {
            console.log('接口缓存读取失败')
        }
    }

    return params => apiFunc(params).then(data => {
        if (data && data.result === 1) {
            const cacheObj = {
                expire: Date.now() + cacheTime,
                data
            };

            localStorage.setItem(key, JSON.stringify(cacheObj));
        }

        return data;
    }).catch(err => {
        console.log(err.message);
    })
}

// 补0
export const addZero = (time) => {
    return time < 10 ? `0${time}` : time;
};

/**
 * 格式化秒
 * @param {*} seconds
 */
 export function formatSeconds(seconds, zero = true, pure = true, floor = true) {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds / 60) % 60);
    const s = floor ? Math.floor(seconds % 60) : seconds % 60;
    if (zero && pure) {
        return `${h > 0 ? addZero(h) + ':' : ''}${addZero(m)}:${addZero(s)}`;
    } else if (zero) {
        return `${h > 0 ? addZero(h) + '时' : ''}${addZero(m)}分${addZero(s)}秒`;
    } else if (pure) {
        return `${h > 0 ? h + ':' : ''}${m}:${s}`;
    } else {
        return `${h > 0 ? h + '时' : ''}${m}分${s}秒`;
    }
}

/**
 * 补正号
 * @param {Number} num
 */
export const supplementaryPlus = (num, isZeroSupplement = false) => {
    if(num > 0){
        return  `+${num}`;
    }else if(num === 0){
        return  `${isZeroSupplement ? '+' : ''}${num}`;
    }else{
        return num
    }
};

/**
 * 获取自适应图片的尺寸
 * @param {Number} naturalWidth 图片真实宽度
 * @param {Number} naturalHeight 图片真实高度
 * @param {Number} adjustWidth 自适应之后的宽度
 */
export const getAdjustSize = (naturalWidth, naturalHeight, adjustWidth) => {
    return {
        naturalWidth,
        naturalHeight,
        width: adjustWidth,
        height: (adjustWidth * naturalHeight) / naturalWidth,
        ratio: adjustWidth / naturalWidth,
    };
};

/**
 * 判断是否为本地环境
 */
export const isDev = () => {
    const host = window.location.host;
    return host !== 'h5.getkwai.com' && host !== 'www.zhongnice.com' && host !== 'h5-imv.prt.kuaishou.com' && host !== 'h5-imv.staging.kuaishou.com';
};

// 获取跨页面（webview）的localStorage
export const getCrossPageStorage = (name, callback) => {
    if(isAndroid()){
        getAppStorage(name, (res) => {
            const resultJSON = JSON.parse(res);
            if(resultJSON.result === 1 && resultJSON.data){
                callback && callback(resultJSON.data);
            }
        });
    }else{
        const value = window?.localStorage?.getItem(name);
        callback && callback(value);
    }
};

// 设置跨页面（webview）的localStorage
export const setCrossPageStorage = (name, value, callback) => {
    if(isAndroid()){
        setAppStorage(name, value, () => {
            callback && callback();
        });
    }else{
        window?.localStorage?.setItem(name, value);
        callback && callback();
    }
};

// 删除跨页面（webview）的localStorage
export const removeCrossPageStorage = (name) => {
    if(isAndroid()){
        removeAppStorage(name);
    }else{
        window?.localStorage?.removeItem(name);
    }
};

/**
 * 获取单个指定数组项的指定对象字段值
 * @param {Array} arr 完成数组
 * @param {String} filterName 指定过滤条件的字段名
 * @param {String} filterValue 指定过滤条件的字段值
 * @param {String} returnName 返回值的字段名
 */
export const getArrayItemObjectValue = (arr, filterName, filterValue, returnName) => {
    const index = arr?.findIndex((item) => item?.[filterName] === filterValue);
    return arr?.[index]?.[returnName];
};
